<template>
  <footer class="footer" data-nosnippet>
    <div class="footer__content">
      <div class="footer__links">
        <router-link to="/privacy-policy" data-nosnippet
          >Privacy Policy</router-link
        >
        <router-link to="/ccpa-opt-out" data-nosnippet
          >Do Not Sell My Information</router-link
        >
        <router-link to="/terms-of-use" data-nosnippet
          >Terms of Use</router-link
        >
       <!--<a href="javascript:void(0)" @click="promptListInventoryDialog"
          >List Your Inventory</a
        >-->
        <a href="javascript:void(0)" @click="promptContactDialog" data-nosnippet
          >Contact Us</a
        >
      </div>
      <div class="q-mt-lg text-grey">
        &copy; {{ new Date().getFullYear() }} {{ $store.state.brand.name }}. All
        Rights Reserved.
      </div>
    </div>
  </footer>
</template>

<script>
import { Dialog } from "quasar";
// import ListInventoryDialog from "@/components/ListInventoryDialog.vue";
import ContactDialog from "@/components/ContactDialog.vue";

export default {
  name: "TheFooter",
  methods: {
    /*promptListInventoryDialog() {
      Dialog.create({
        component: ListInventoryDialog
      });
    },*/
    promptContactDialog() {
      Dialog.create({
        component: ContactDialog
      });
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  background: color(background);
  color: color(text, light);

  .footer__content {
    @include contain-content-width;
    padding: $space-xl $space-lg;
    @include display-flex(column, flex-start, center);
    font-size: 0.8em;

    @include screen-md {
      padding-bottom: 100px;
    }

    .footer__links {
      @include display-flex(row);
      font-weight: 500;

      @include screen-sm {
        font-size: 0.85em;
        text-align: center;
        @include display-flex(column, center, center);
      }

      a {
        margin: 0 $space-md;
        color: color(text);
        text-decoration: none;

        @include screen-sm {
          margin: 0.5rem 0.75rem !important;
        }

        &:first-of-type {
          margin-left: 0;
        }
        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
